export function usageRequest(state = {
    fetching:false,
    fetched: false,
    error:null,
},{
    type,
    payload
}){
    
    switch(type){
        case "CREATE_USAGE_START":           
        case "FETCH_USAGES_START":                                 
        case "UPDATE_USAGE_START":                                 
            return {
                ...state, 
                fetching:true,
            }        
        case "CREATE_USAGE_FULFILLED":           
        case "FETCH_USAGES_FULFILLED":                                 
        case "UPDATE_USAGE_FULFILLED":                                 
            return {
                ...state,
                fetching:false, 
                fetched:true, 
                error: null
            }    
        case "CREATE_USAGE_ERROR":
        case "FETCH_USAGES_ERROR":
        case "UPDATE_USAGE_ERROR":
            return {
                ...state,
                fetching:false, 
                error:payload
            }
        default:
            return state;
    }
    
}